import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ResolverService } from 'src/app/___LOGIC/__common/resolver.service';
import { DialogData } from 'src/app/___LOGIC/__interfaces/DialogData';

@Component({
  selector: 'app-pack-details-modal',
  templateUrl: './pack-details-modal.component.html',
  styleUrls: ['./pack-details-modal.component.css']
})
export class PackDetailsModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public loadedData: DialogData,private resolver: ResolverService) { }

  ngOnInit(): void {
  }

  getPackDetails(label){
    if(this.loadedData && this.loadedData['pack']){
      return this.loadedData['pack'][label];
    }else{
      return '';
    }
  }

  isLoading(){
    return this.resolver.isLoading('getPackDetails');
  }

  getCurrentList(){
    return [...(this.loadedData?.['producList'] ?? [])];
  }

}
